import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=99f58ace&scoped=true&"
import script from "./Nav.vue?vue&type=script&lang=js&"
export * from "./Nav.vue?vue&type=script&lang=js&"
import style0 from "./Nav.vue?vue&type=style&index=0&id=99f58ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f58ace",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavContent: require('/opt/build/repo/components/NavContent.vue').default})
